<template>
	<div class="home">
		<el-container>
			<el-header class="header">
				<Top />
			</el-header>
			<el-main class="main">
				<Banner class="banner" v-if="type == 'index'"/>
				<We v-if="type == 'We'"/>
				<Develop  v-if="type == 'Develop'"/>
				<Vision  v-if="type == 'Vision'"/>
				<Address  v-if="type == 'Address'"/>
			</el-main>
			<el-footer>
				<Footer />
			</el-footer>
		</el-container>
	</div>
</template>

<script>
	import Top from './Top.vue'
	import Banner from './Banner.vue'
	import We from './We.vue'
	import Develop from './Develop.vue'
	import Vision from './Vision.vue'
	import Address from './Address.vue'
	import Footer from './Footer.vue'
	export default {
		name: 'home',
		components: {
			Top,
			Banner,
			Footer,
			We,
			Develop,
			Vision,
			Address,
		},
		computed:{
			type(){
				let num = 'index';
				if (typeof(this.$route.query.map) == 'undefined') {
					num = 'index'
				}else{
					num = this.$route.query.map
				}
				return num;
			}
		},
		mounted() {

		},
		methods: {

		},
	}
</script>
<style lang="scss" scoped="scoped">
	.home{
		.el-main{
			padding: 0 !important;
		}
		.header{
			width: 100%;
			position: fixed;
			top: 0;
			z-index: 99;
		}
	}
</style>
